import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogContent, DialogTitle, IconButton,
} from '@material-ui/core';
import moment from 'moment-timezone';
import { Clear } from '@material-ui/icons';
import CustomTable from '../common/Table';

const getFields = () => ([
  {
    header: '#', key: 'id', format: true,
  },
  {
    header: 'Reason', key: 'reason',
  },
  {
    header: 'Changed To', key: 'status_text',
  },
  {
    header: 'Changed At', key: 'created_at',
  },
]);

const PickupsStatusHistoryModal = ({
  handleClose, open, pickup, serverTimezone,
}) => (
  <Dialog
    className="confirmation-dialog"
    open={open}
    onClose={handleClose}
    aria-labelledby="preview-modal-title"
    PaperProps={{
      style: {
        minHeight: '200px',
        maxHeight: '90vh',
      },
    }}
  >
    <DialogTitle id="preview-modal-title">
      Pickup Status History
      <IconButton onClick={handleClose}>
        <Clear />
      </IconButton>
    </DialogTitle>
    <DialogContent className="preview-item-container text-center" id="preview-modal-dialog">
      <CustomTable
        rows={pickup.status_histories}
        formatters={{
          id: (_, indx) => (indx + 1),
          created_at: value => moment(value).tz(serverTimezone).format('MM.DD.YYYY hh:mm a zz'),
        }}
        rowsProps={getFields()}
        suffix="pickup_status_history"
      />
    </DialogContent>
  </Dialog>
);

PickupsStatusHistoryModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  pickup: PropTypes.instanceOf(Array).isRequired,
  serverTimezone: PropTypes.string.isRequired,
};

PickupsStatusHistoryModal.defaultProps = {
  open: false,
};

export default PickupsStatusHistoryModal;
